import listTemplate from './views/pages/list.tpl.html';
import TicketTemplatesListController from './controllers/pages/list-controller';
import TicketTemplateCreateController from './controllers/pages/create-controller';
import editTemplate from './views/pages/editor.tpl.html';
import createTemplate from './views/pages/create.tpl.html';
import TicketTemplateEditController from './controllers/pages/edit-controller';

angular
    .module('festzelt-os.modules.tickets.templates')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.tickets.templates', {
            abstract: true,
            url: 'templates',
            template: '<ui-view/>',
        })
        .state('app.tickets.templates.index', {
            url: '/',
            sticky: true,
            templateUrl: listTemplate,
            controller: TicketTemplatesListController,
            controllerAs: 'vm',
            data: {
                right: 'tickets::templates-list'
            }
        })
        .state('app.tickets.templates.edit', {
            url: '/{id}/edit',
            templateUrl: editTemplate,
            controller: TicketTemplateEditController,
            controllerAs: 'vm',
            data: {
                bodyClass: 'wide',
                collapsedSidebarOnLoad: true
            }
        })
        .state('app.tickets.templates.create', {
            url: '/create',
            templateUrl: createTemplate,
            controller: TicketTemplateCreateController,
            controllerAs: 'vm',
            data: {
                right: 'tickets::templates-edit',
                collapsedSidebarOnLoad: true
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/routes.js